// extracted by mini-css-extract-plugin
export default {"counterContainer":"Counter_counterContainer__SSRQ2","title":"Counter_title__JK8PB","text":"Counter_text__5dKlZ","iconContainer":"Counter_iconContainer__1DhLZ"};